import { AiChat } from '@/assets/icons'
import { Button } from '@/components/button/Button'
import { IconButton } from '@/components/icon-button/IconButton'
import { useStartTimelineAssetChat } from '../hooks/useStartTimelineAssetChat'

interface TimelineAssetChatButtonProps {
  assetId: string
  matterId: string
  compact?: boolean
}

/**
 * Starts a new assistant chat grounded in the matter's living Timeline.
 */
export default function TimelineAssetChatButton(props: TimelineAssetChatButtonProps) {
  const { assetId, matterId, compact = false } = props
  const { isLoading, startChat } = useStartTimelineAssetChat({ assetId, matterId })

  if (compact) {
    return (
      <IconButton
        onClick={() => startChat()}
        disabled={isLoading}
        loading={isLoading}
        variant="plain"
        color="primary"
        size="lg"
        icon={<AiChat />}
        aria-label="Chat with the Timeline"
      />
    )
  }

  return (
    <Button
      onClick={() => startChat()}
      disabled={isLoading}
      loading={isLoading}
      variant="outlined"
      color="primary"
      size="sm"
      leadingIcon={<AiChat />}
      aria-label="Chat with the Timeline"
    >
      Ask Assistant
    </Button>
  )
}
